import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../redux/store';

type AuthState = {
    user: any | "Pedro Arruebo Local";
    accessToken?: string | null;
    refreshToken?: string | null;
};

const initialState = { user: null, accessToken: null, refreshToken: null } as AuthState;

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken: (state, { payload }) => {
            state.accessToken = payload;
        },
        setRefreshToken: (state, { payload }) => {
            state.refreshToken = payload;
        },
        setUserData: (state, { payload }) => {
            state.user = payload;
        },
        logout: () => initialState
    }
});

export default authSlice.reducer;

export const { logout, setAccessToken, setRefreshToken, setUserData } = authSlice.actions;

export const selectCurrentUser = (state: RootState) => state.auth.user;
